import { AppBox } from "../../../../commons/components";
import { IFootballCompetition } from "../../../../commons/models/football/interface/i-football-competition";

interface TournamentDeleteProps {
  tournament: IFootballCompetition;
}
export default function TournamentDelete({ tournament }: TournamentDeleteProps) {
  return (
    <AppBox displayBlock>
      Do you want to delete <strong>“{tournament.title}”</strong> permanently? Once you delete the tournament, the
      action cannot be undone.
    </AppBox>
  );
}
